<template>
  <div class="full-page notice-detail">
    <h1 class="title">{{ title }}</h1>

    <div class="content reset-rich-text" v-html="content"></div>
    <div class="bottom-line">
      <div class="cross-line"></div>
      <div class="bottom-text">我是有底线的</div>
      <div class="cross-line"></div>
    </div>
  </div>
</template>
<script>
import { newsDetailAPI } from "@/api/news";
import { BridgeNativeMethods } from "@/assets/js/jsbridge";
import { checkResponse, TimeFormat } from "@/assets/js/utils";
export default {
  name: "NewsDetail",
  data() {
    return {
      title: "",
      content: ""
    };
  },
  computed: {
    createTimeText() {
      return TimeFormat.timestampSecondToChinese(this.creationTime);
    },
  },
  mounted() {
        BridgeNativeMethods.setTitle("");
        this.title = this.$route.query.title
    this.requestData(this.$route.params.id);

  },
  methods: {
    requestData(id) {
      newsDetailAPI(id).then(
        (response) => {
          if (checkResponse(response)) {
            let { content } = response.data;
            this.content = content
          } else {
            BridgeNativeMethods.showToast(response.message);
          }
        },
        (err) => {
          BridgeNativeMethods.showToast("请求错误");
          console.log(err);
        }
      );
    },
  },
};
</script>
<style lang="less" scoped>
.notice-detail {
  background: #fff;
  padding: 12px 16px 16px;
   &:after {
        position: absolute;
        box-sizing: border-box;
        content: ' ';
        pointer-events: none;
      top:0;
      left:0;
      right:0;
        border-bottom: 1px solid #EEEEEE;
        -webkit-transform: scaleY(0.5);
        transform: scaleY(0.5);
    }
}
.title {
  font-size: 24px;
  font-weight: bold;
  color: #333333;
  line-height: 34px;
  margin:0;
  padding:0;
}
.info {
  font-size: 12px;
  color: #999999;
  line-height: 16px;
}
.main-img {
    display: block;
    width: 100%;
    height: auto;
    margin-top: 48px;
    margin-bottom: 48px;
}
.bottom-line {
  padding-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  color: #cccccc;
  line-height: 19px;
}
.bottom-text {
  margin-left: 10px;
  margin-right: 10px;
}
.scross-line {
  width: 40px;
  height: 1px;
  background: #dddddd;
}
</style>